import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import ContactForm from '../components/forms/ContactForm';

const equipment = [
  {
    id: 'ktpn',
    title: 'КТПН',
    description:
      'Комплектные трансформаторные подстанции наружной установки для приема, преобразования и распределения электроэнергии.',
    features: [
      'Мощность от 25 до 2500 кВА',
      'Напряжение 6/0,4 кВ или 10/0,4 кВ',
      'Различные типы исполнения (киосковые, мачтовые)',
      'Комплектация по требованию заказчика',
    ],
    image:
      'https://images.pexels.com/photos/9875441/pexels-photo-9875441.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
  },
  {
    id: 'kso',
    title: 'КСО',
    description:
      'Камеры сборные одностороннего обслуживания для распределительных устройств 6-10 кВ.',
    features: [
      'Номинальное напряжение 6-10 кВ',
      'Номинальный ток до 1000 А',
      'Различные схемы главных цепей',
      'Механическая и электромагнитная блокировка',
    ],
    image:
      'https://images.pexels.com/photos/3862136/pexels-photo-3862136.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
  },
  {
    id: 'cable',
    title: 'Кабель',
    description: 'Силовой и контрольный кабель различных марок для промышленных объектов.',
    features: [
      'Силовой кабель (ВВГ, АВБбШв)',
      'Контрольный кабель (КВВГ, КВВГнг)',
      'Гибкий кабель (КГ, КГ-ХЛ)',
      'Различные сечения и количество жил',
    ],
    image:
      'https://images.pexels.com/photos/1109541/pexels-photo-1109541.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
  },
];

export default function EquipmentPage() {
  return (
    <>
      <Helmet>
        <title>Смежное оборудование - КТПН, КСО, кабель | Проминнова</title>
        <meta
          name="description"
          content="Комплексные решения для энергетики: КТПН, КСО и кабель от компании Проминнова. Качественное оборудование с доставкой по РФ и СНГ."
        />
      </Helmet>

      <div className="bg-primary-50 py-12">
        <div className="container-custom">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            КТПН, КСО и кабель для ваших проектов
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl">
            Комплексные решения для энергоснабжения промышленных и гражданских объектов
          </p>
        </div>
      </div>

      <div className="container-custom py-16">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-16">
          {equipment.map((item) => (
            <div
              key={item.id}
              className="bg-white rounded-lg shadow-sm border border-gray-100 overflow-hidden"
            >
              <div className="h-48 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover"
                  loading="lazy"
                  width="341"
                  height="192"
                />
              </div>
              <div className="p-6">
                <h2 className="text-2xl font-bold mb-4">{item.title}</h2>
                <p className="text-gray-600 mb-4">{item.description}</p>
                <ul className="space-y-2 mb-6">
                  {item.features.map((feature, index) => (
                    <li key={index} className="flex items-center text-gray-600">
                      <div className="w-2 h-2 bg-primary-500 rounded-full mr-3"></div>
                      {feature}
                    </li>
                  ))}
                </ul>
                <Link
                  to={`/catalog/${item.id}`}
                  className="inline-flex items-center text-primary-600 font-medium hover:text-primary-700"
                >
                  Подробнее
                  <ArrowRight className="ml-2 w-4 h-4" />
                </Link>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            <div>
              <h2 className="text-3xl font-bold mb-4">
                Нужна консультация по подбору оборудования?
              </h2>
              <p className="text-gray-600 mb-6">
                Наши специалисты помогут подобрать оптимальное решение для вашего проекта и
                рассчитают стоимость комплекта оборудования.
              </p>
              <div className="space-y-4">
                <div className="flex items-center">
                  <div className="w-2 h-2 bg-primary-500 rounded-full mr-3"></div>
                  <span>Бесплатный расчет стоимости</span>
                </div>
                <div className="flex items-center">
                  <div className="w-2 h-2 bg-primary-500 rounded-full mr-3"></div>
                  <span>Техническая консультация</span>
                </div>
                <div className="flex items-center">
                  <div className="w-2 h-2 bg-primary-500 rounded-full mr-3"></div>
                  <span>Помощь в подборе оборудования</span>
                </div>
              </div>
            </div>
            <div>
              <ContactForm buttonText="Получить консультацию" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
